export const MAPBOX_ACCESS_TOKEN =
  "pk.eyJ1Ijoia2V2bW8zMTQiLCJhIjoiY2twY3hidXAyMWE1bzJ4bngxczJjdzNhcyJ9.86H7x0kXIVRLAF_cdpwKkQ";